import { render, staticRenderFns } from "./EntranceTestScheduleItem.vue?vue&type=template&id=1cb3ab8b&scoped=true"
import script from "./EntranceTestScheduleItem.vue?vue&type=script&lang=js"
export * from "./EntranceTestScheduleItem.vue?vue&type=script&lang=js"
import style0 from "./EntranceTestScheduleItem.vue?vue&type=style&index=0&id=1cb3ab8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb3ab8b",
  null
  
)

export default component.exports